import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';

// COLE SUAS CREDENCIAIS DO FIREBASE AQUI
export const firebaseConfig = {
  apiKey: "AIzaSyDfXhx2vbmqIuZr4Jp9JSCpV7OjPlK_ra8",
  authDomain: "controle-dengue-eunapolis-2025.firebaseapp.com",
  projectId: "controle-dengue-eunapolis-2025",
  storageBucket: "controle-dengue-eunapolis-2025.firebasestorage.app",
  messagingSenderId: "844611576473",
  appId: "1:844611576473:web:58351cf31cd9c3c0d00e08"
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);

// Inicializa o Auth
const auth = getAuth(app);

// Inicializa o Firestore com Cache Persistente (Modo novo)
const firestore = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export { auth, firestore };